import createSearchWordStore from '~/mixins/searchWordStore';

export default createSearchWordStore('tender');
